module.exports = __webpack_public_path__ + "img/login-bg.ccf3c929.png";